import React from "react";
import { Stack } from "@mui/material";
import { useFieldArray } from "react-hook-form";

import ShipmentBoxesTableHeader from "./ShipmentBoxesTableHeader";
import ShipmentBoxesTableBody from "./ShipmentBoxesTableBody";
import ShipmentBoxesTableAddRow from "./ShipmentBoxesTableAddRow";

export const ShipmentBoxesTable = ({ disabled }) => {
  const fieldArrayOptions = useFieldArray({
    name: "boxes",
    rules: {
      required: "At least 1 Package is required",
    },
  });
  const { append, remove, fields } = fieldArrayOptions;

  return (
    <Stack width="100%" overflow="hidden">
      <ShipmentBoxesTableHeader />
      <ShipmentBoxesTableBody {...{ disabled, remove, fields }} />
      <ShipmentBoxesTableAddRow {...{ disabled, handleWorkOrderAdd: append }} />
    </Stack>
  );
};

export default ShipmentBoxesTable;
